import {
  startBugsnag,
  isBrowserSupported,
  defineInitFunction,
} from '../../common/init';
import {defineElement as defineShopLoginButtonElement} from '../../components/loginButton/shop-login-button';
import {defineElement as defineShopLoginDefaultElement} from '../../components/loginButton/shop-login-default';

import {initCustomerAccounts} from './initCustomerAccounts';

/**
 * Initialize the initCustomerAccounts function.
 */
function init() {
  if (!isBrowserSupported()) return;
  startBugsnag({
    bundle: 'initCustomerAccounts',
    // eslint-disable-next-line no-process-env
    bundleLocale: process.env.BUILD_LOCALE,
  });

  defineShopLoginButtonElement();
  defineShopLoginDefaultElement();
  defineInitFunction('initCustomerAccounts', initCustomerAccounts);
}

init();
